import { Breadcrumbs } from "components/breadcrumbs";
import { useCreate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AdminAccountForm } from "./components";
import { IAdminAccountForm } from "interfaces";

export const CreateAdminAccount: React.FC = () => {
  const { mutate, isLoading: isSubmitingSubCategoryForm } = useCreate();
  const navigate = useNavigate();

  const onSubmit = (values: IAdminAccountForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "admin-account/account",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
        },
      },
      {
        onSuccess: () => {
          toast.success("Create successfully");
          navigate(`/admin-accounts/accounts`);
        },
      }
    );
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create New Admin Account" />
      <AdminAccountForm onSubmit={onSubmit} />
      {isSubmitingSubCategoryForm ? <FullScreenLoading /> : <></>}
    </div>
  );
};
